import { AITrace } from "../models/aiTrace";
import axiosConfig from "./axiosConfig";

// Fetch the complete AI trace from a landlord-research run. Returns null
// when no trace is available (a missing run, or a trace not copied into a
// non-prod env). With a runId it fetches that specific run; without one the
// BE returns the subject's most recent trace, so a row researched in another
// session (whose run id the FE never held) is still viewable.
const getLandlordResearchTrace = async (
  authToken: string,
  subjectRef: string,
  runId?: string | null
): Promise<AITrace | null> => {
  const { data } = await axiosConfig.get(`/leads/landlord-research-trace`, {
    params: runId ? { subjectRef, runId } : { subjectRef },
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data?.trace ?? null;
};

export default getLandlordResearchTrace;
